import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    padding: 10px 24px;
    display: flex;
    align-items: center;

    color: ${theme.colors.secondary};
    background: red;
  `}
`

export const Footerlabel = styled(Box)`
  height: 48px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const FooterValue = styled(Box)`
  font-weight: 700;
`
